import React from 'react';
import astronautLeft from '../assets/tinkerlabs__web__fig1.webp';
import astronautRight from '../assets/tinkerlabs__web__fig2.webp';

import svvg1 from '../assets/svvg1.svg';
import svvg2 from '../assets/svvg2.svg';
import svvg3 from '../assets/svvg3.svg';
import svvg4 from '../assets/svvg4.svg';
import svvg5 from '../assets/svvg5.svg';
import svvg6 from '../assets/svvg6.svg';

const WhatYouGet = ({toSection,section}) => {
    const items = [
        {
          title: "A Comprehensive Launch Plan",
          description: "We're committed to your success because, simply put, your success is our success. We'll go above and beyond to support you in launching and growing your new business.",
          position: "right",
          svg: svvg1,
          color: "#7aa6bf"
        },
        {
          title: "Dedicated Franchise Manager",
          description: "Gain the advantage of having a dedicated business coach by your side. They'll guide you through best practices and help you avoid common pitfalls that many new franchisees face.",
          position: "left",
          svg: svvg2,
          color:'#f0904c'
        },
        {
          title: "Lesson Plans and Curriculum",
          description: "Our team is continually developing new courses and learning materials to keep students engaged and up-to-date with the latest in technology, ensuring a curriculum that's always fresh and relevant.",
          position: "right",
          svg: svvg3,
          color: "#ee3e86"
        },
        {
          title: "Information Management Software",
          description: "Starting with the right tech and systems is crucial but can be overwhelming. Don't worry - we've got it covered with fully set-up websites, social media integration, booking software, CRM, and marketing tools.",
          position: "left",
          svg: svvg4,
          color: "#7aa6bf"
        },
        {
          title: "Marketing Expertise",
          description: "Our marketing team is here to boost your visibility, promoting your classes, camps, and events across web and social media channels. We've also created a range of advertising materials and sales aids to make marketing easier for you.",
          position: "right",
          svg: svvg5, // Using existing SVG - replace with actual marketing SVG when available
          color: "#f0904c"
        },
        {
          title: "Your Own Franchise Network",
          description: "The strength of our franchise lies in the power of its community. At Tinker Labs, you'll join a culture-focused, supportive network of like-minded, ethical entrepreneurs who are here to grow together.",
          position: "left",
          svg: svvg6, // Using existing SVG - replace with actual network SVG when available
          color: "#ee3e86"
        }
      ];

      return (
        <div style={{marginTop: '-40px'}} id={section} className="relative bg-[#002147]">
          {/* Top wave */}
          <div style={{zIndex: 1}} className="absolute top-0 left-0 right-0 bg-[#002147]">
            <svg 
              viewBox="0 0 1440 200" 
              className="w-full"
              preserveAspectRatio="none"
              style={{ height: '120px', transform: 'rotate(180deg)' }}
            >
              <path 
                fill="#B8E1FF"
                fillOpacity="1" 
                d="M0,160L48,144C96,128,192,96,288,80C384,64,480,64,576,80C672,96,768,128,864,128C960,128,1056,96,1152,80C1248,64,1344,64,1392,64L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
              />
            </svg>
          </div>
      {/* Floating astronauts */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 z-10">
          <img 
            src={astronautLeft}
            alt="Left floating astronaut" 
            className="w-40 h-auto animate-float"
          />
        </div>
        <div className="absolute right-0 top-1/2 -translate-y-1/2 z-10">
          <img 
            src={astronautRight}
            alt="Right floating astronaut" 
            className="w-40 h-auto animate-float-delayed"
          />
        </div>
          <div className="bg-[#002147] relative py-20 ">
            <div className="container mx-auto px-4 bg-[#002147]">
              <h2 className="font-['Grandstander'] mt-10 text-4xl font-extrabold text-center text-white mb-16">
              What do you get?
              </h2>
    
              <div className="relative max-w-4xl mx-auto">
                {/* Central Timeline Line */}
                <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-[#fff] midleline" />
    
                {/* Timeline Items */}
                {items.map((item, index) => (
                  <div key={index} className="relative flex items-center mb-16">
                    {/* Content Box */}
                    <div className={`w-5/12 blockget ${item.position === 'left' ? 'mr-auto pr-8' : 'ml-auto pl-8'}`}>
                      <div className="bg-[#fff] text-[#002147] p-6 rounded-xl shadow-lg">
                        <h3 className="font-['Lexend'] text-lg font-semibold mb-2">
                          {item.title}
                        </h3>
                        <p className="font-['Lexend'] text-sm leading-relaxed">
                          {item.description}
                        </p>
                      </div>
                    </div>
    
                    {/* Timeline Icon */}
                    <div className="absolute bicons left-1/2 transform -translate-x-1/2 flex items-center justify-center">
                      <div style={{backgroundColor:item.color}} className="w-16 h-16 rounded-full flex items-center justify-center">
                        <img
                            src={item.svg}
                            alt={item.title}
                            className="w-8 h-8"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
    
            {/* Decorative Elements */}
           
          </div>
    
          {/* Bottom wave */}
          <div className="absolute bottom-0 left-0 right-0">
            <svg 
              viewBox="0 0 1440 200" 
              className="w-full"
              preserveAspectRatio="none"
              style={{ height: '120px' }}
            >
              <path 
                fill="#002147"
                d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
              />
            </svg>
          </div>
        </div>
      );
    };

export default WhatYouGet;